import { Component } from '@angular/core';
import { Router } from '@angular/router';

interface GeoToolCard {
  id: 'gis' | 'lrs' | 'assets' | 'boq';
  name: string;
  blurb: string;
  description: string;
  features: string[];
  iconLabel: string;
  accent: string;
  cta: string;
  route: string;
  queryParams?: Record<string, string>;
}

@Component({
  selector: 'app-geospatial-dashboard',
  templateUrl: './geospatial-dashboard.component.html',
  styleUrls: ['./geospatial-dashboard.component.css'],
})
export class GeospatialDashboardComponent {
  readonly cards: GeoToolCard[] = [
    {
      id: 'gis',
      name: 'GIS Editor',
      blurb: 'Map workspace',
      description: 'Draw and edit layers, alignments, and site geometry on the project map.',
      features: ['OpenLayers map editor', 'Layer drawing and attributes', 'Project-scoped GIS'],
      iconLabel: 'GIS',
      accent: '#2563eb',
      cta: 'Open GIS Editor →',
      route: '/home/geospatial',
      queryParams: { view: 'gis' },
    },
    {
      id: 'lrs',
      name: 'LRS',
      blurb: 'Linear referencing',
      description: 'Locate chainage, calibrate routes, and work with events and utilities on the corridor.',
      features: ['Chainage locate', 'Route calibration', 'LRS dashboard on the map'],
      iconLabel: 'LRS',
      accent: '#0f766e',
      cta: 'Open LRS →',
      route: '/home/geospatial',
      queryParams: { view: 'lrs', tab: 'lrs' },
    },
    {
      id: 'boq',
      name: 'Road BoQ',
      blurb: 'Quantities from the corridor',
      description: 'Build a road BoQ from LRS chainage: pavement L×W×T, shoulders, and asset counts on the map.',
      features: ['Chainage span and cross-section', 'Pavement volume table', 'Apply to Road BoQ'],
      iconLabel: 'BoQ',
      accent: '#7c3aed',
      cta: 'Open Road BoQ →',
      route: '/home/geospatial',
      queryParams: { view: 'boq' },
    },
    {
      id: 'assets',
      name: 'Asset management',
      blurb: 'Registry and ERP',
      description: 'Manage GIS asset layers and features, then send create or edit work to the map.',
      features: ['Asset layers and features', 'Audit trail', 'Handoff to map editor'],
      iconLabel: 'AST',
      accent: '#b45309',
      cta: 'Open Asset console →',
      route: '/home/asset-management',
    },
  ];

  constructor(private router: Router) {}

  openCard(card: GeoToolCard): void {
    void this.router.navigate([card.route], {
      queryParams: card.queryParams || undefined,
    });
  }
}
